export const platforms = [
  {
    id: 'all',
    name: 'Semua',
    color: '#444',
    placeholder: 'Paste link video dari platform manapun...',
    pattern: null,
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10"/>
        <path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/>
      </svg>
    ),
  },
  {
    id: 'youtube',
    name: 'YouTube',
    color: '#FF0000',
    placeholder: 'https://youtube.com/watch?v=...',
    pattern: /youtube\.com|youtu\.be/i,
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
        <path d="M23 7s-.3-2-1.2-2.8c-1.1-1.2-2.4-1.2-3-1.3C16.4 2.8 12 2.8 12 2.8s-4.4 0-6.8.1c-.6.1-1.9.1-3 1.3C1.3 5 1 7 1 7S.7 9.1.7 11.2v2c0 2.1.3 4.2.3 4.2s.3 2 1.2 2.8c1.1 1.2 2.6 1.1 3.3 1.2C7.5 21.6 12 21.7 12 21.7s4.4 0 6.8-.2c.6-.1 1.9-.1 3-1.3.9-.8 1.2-2.8 1.2-2.8s.3-2.1.3-4.2v-2C23.3 9.1 23 7 23 7zM9.7 15.5V8.4l8.1 3.6-8.1 3.5z"/>
      </svg>
    ),
  },
  {
    id: 'instagram',
    name: 'Instagram',
    color: '#E1306C',
    gradientBg: 'linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045)',
    placeholder: 'https://instagram.com/p/...',
    pattern: /instagram\.com/i,
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
        <circle cx="12" cy="12" r="4"/>
        <circle cx="17.5" cy="6.5" r="1" fill="white" stroke="none"/>
      </svg>
    ),
  },
  {
    id: 'threads',
    name: 'Threads',
    color: '#E1306C',
    gradientBg: 'linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045)',
    placeholder: 'https://www.threads.com/...',
    pattern: /threads\.com/i,
    icon: (
      <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth={2}>
			<path d="M12 3c4.5 0 7.5 2.5 7.5 6.5 0 3.5-2.5 5.5-5.5 5.5-2.5 0-4-1.5-4-3 0-1.2.8-2.2 2.2-2.2 1.5 0 2.3 1 2.3 2.3v1c1.5-.2 2.5-1.5 2.5-3.3 0-2.5-2-4-5-4-3.5 0-5.5 2-5.5 5.5v3c0 3.5 2 5.5 5.5 5.5 2.5 0 4.5-1 5.5-3" strokeLinecap="round" strokeLinejoin="round"/>
	  </svg>
    ),
  },
  {
    id: 'facebook',
    name: 'Facebook',
    color: '#1877F2',
    placeholder: 'https://facebook.com/watch?v=...',
    pattern: /facebook\.com|fb\.watch/i,
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
      </svg>
    ),
  },
  {
    id: 'tiktok',
    name: 'TikTok',
    color: '#010101',
    placeholder: 'https://tiktok.com/@user/video/...',
    pattern: /tiktok\.com/i,
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.94a8.14 8.14 0 004.77 1.52V7.02a4.85 4.85 0 01-1-.33z"/>
      </svg>
    ),
  },
  {
    id: 'twitter',
    name: 'X / Twitter',
    color: '#000000',
    placeholder: 'https://x.com/user/status/...',
    pattern: /twitter\.com|x\.com/i,
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
  },
  {
    id: 'doodstream',
    name: 'Doodstream',
    color: '#6C4BFF',
    placeholder: 'https://dood.watch/d/...',
    pattern: /dood\.|doodstream\.com/i,
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
        <polygon points="5 3 19 12 5 21 5 3"/>
      </svg>
    ),
  },
];

export const features = [
  {
    title: 'Resolusi Tinggi',
    desc: 'Unduh hingga kualitas 4K, 1080p, 720p sesuai kebutuhan',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="2" y="3" width="20" height="14" rx="2"/>
        <path d="M8 21h8M12 17v4"/>
        <path d="M7 8h2l1 3 1-4 1 3h2"/>
      </svg>
    ),
  },
  {
    title: 'Multi Format',
    desc: 'Pilih MP4, MP3, WebM, atau format lainnya',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
        <polyline points="10 9 9 9 8 9"/>
      </svg>
    ),
  },
  {
    title: 'Tanpa Watermark',
    desc: 'Video bersih tanpa logo atau tanda apapun',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <polyline points="9 12 11 14 15 10"/>
      </svg>
    ),
  },
  {
    title: 'Tanpa Registrasi',
    desc: 'Langsung pakai, tidak perlu akun atau login',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z"/>
        <polyline points="13 2 13 9 20 9"/>
      </svg>
    ),
  },
  {
    title: 'Unduhan Cepat',
    desc: 'Server dioptimalkan untuk kecepatan maksimal',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
      </svg>
    ),
  },
  {
    title: '100% Gratis',
    desc: 'Semua fitur gratis selamanya, tanpa iklan berbayar',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="12" r="10"/>
        <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
        <line x1="9" y1="9" x2="9.01" y2="9"/>
        <line x1="15" y1="9" x2="15.01" y2="9"/>
      </svg>
    ),
  },
];

export const formats = [
  { label: 'MP4', sub: '1080p', popular: true },
  { label: 'MP4', sub: '720p', popular: false },
  { label: 'MP4', sub: '480p', popular: false },
  { label: 'MP3', sub: '320kbps', popular: false },
  { label: 'MP3', sub: '128kbps', popular: false },
  { label: 'WebM', sub: '1080p', popular: false },
];
